/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import { Box, Label } from 'irmlib/components/Controls'
import styled from 'styled-components'
import { FlexByRow, XDivider, YDivider, useTheme } from '../../../irmlib/src/styles'
import { TextField } from 'irmlib/components/FormControls'
import { useMergeState } from '../../../irmlib/src/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

// AI code — compact spacing for QC pages
const BoxUp = styled('div')`
  background-color: ${props => props.theme.palette.subPageHeaderBackground};
  padding: ${props => (props.$compact ? '12px 20px' : '30px')};
  margin-bottom: ${props => (props.$compact ? '8px' : '20px')};
`

const BoxStyle = styled('div')`
    width: 25%; 
    padding-left: 10px;
    padding-bottom: 10px;
`

const LableStyle = styled('div')`
  border-right: 1px solid;
`

const EvenSpace = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const WidthForTextBox = styled('div')`
  width: 33%;
`

const MarginLeft = styled('div')`
  margin-left: 10px;
`

// const getService = async () => {
//   const getObject = {
//     obj: {

//     }
//   }
//   return Promise.resolve(getObject)
// }

const initialState = {
  customerId: '',
  templateName: '',
  dataKeyed: '',
  skpBoxId: '',
  divisionId: '',
  departmentId: ''
}

const SummaryHeader = (props) => {
  // const [arrRefs, data] = useFormPageHandler({
  //   formTemplate,
  //   service: getService,
  // })
  const { t } = useTranslation()
  const [state, setState] = useMergeState(initialState)
  const theme = useTheme()

  const SKPBOX = 0
  const DIVISIONBOX = 1
  const DEPARTMENTBOX = 2

  useEffect(() => {
    if (props.jobSummary) {
      setState({
        customerId: props.jobSummary.customerId,
        templateName: props.jobSummary.templateName,
        dataKeyed: '',
        divisionId: props.jobSummary.divisionId,
        departmentId: props.jobSummary.departmentId
      })
      return
    }
    getSummaryData()
  }, [props.jobId, props.jobSummary])

  const formTemplate = [
    {
      label: ('dataEntry.skpBoxID'),
      fieldKey: 'obj.obj1.skpId',
    },
    {
      label: ('dataEntry.divisionID'),
      fieldKey: 'obj.obj1.divisionId'
    },
    {
      label: ('dataEntry.departmentID'),
      fieldKey: 'obj.obj1.departmentId',
    },
  ]
  
  const getSummaryData = async () => {
    const summaryDataDoc = await (await gdeTransactions.getJobById(props.jobId)).data()

    setState({
      customerId: summaryDataDoc.accountLevel1.toUpperCase(),
      templateName: summaryDataDoc.templateName ? summaryDataDoc.templateName : summaryDataDoc.standardTemplateName,
      dataKeyed: '',
      divisionId: summaryDataDoc.accountLevel2.toUpperCase(),
      departmentId: summaryDataDoc.accountLevel3
    })
  }

  return (
    <BoxUp theme={theme} $compact={props.compact}>
      {/* <LocalToast ref={refLocalToast} /> */}
      <FlexByRow>
        <BoxStyle theme={theme}>
          <Box>
            <LableStyle><Label noTranslate={true}>{t('dataEntry.jobId')}</Label></LableStyle>
            <YDivider />
            <LableStyle><Label noTranslate>{props.jobId}</Label></LableStyle>
          </Box>
        </BoxStyle>
        <BoxStyle theme={theme}>
          <Box>
            <LableStyle><Label noTranslate={true}>{t('dataEntry.customerId')}</Label></LableStyle>
            <YDivider />
            <LableStyle><Label noTranslate>{state.customerId}</Label></LableStyle>
          </Box>
        </BoxStyle>
        <BoxStyle theme={theme}>
          <Box>
            <LableStyle><Label noTranslate={true}>{t('dataEntry.templateName')}</Label></LableStyle>
            <YDivider />
            <LableStyle><Label noTranslate>{state.templateName}</Label></LableStyle>
          </Box>
        </BoxStyle>
        {props.qualityCheck
          ? null
          : <BoxStyle theme={theme}>
            <Box>
              {props.templateType 
                ? <Label noTranslate={true}>{t('dataEntry.filesKeyed')}</Label> 
                : <Label noTranslate={true}>{t('dataEntry.boxesKeyed')}</Label>}
              <YDivider />
              <Label noTranslate>{props.dataKeyed}</Label>
            </Box>
          </BoxStyle>}
      </FlexByRow>
      {props.templateType
        ? <><YDivider height='15px' /><EvenSpace>
          {props.qualityCheck
            ? null
            : <><WidthForTextBox>
              <MarginLeft>
                <TextField
                  fieldTemplate={formTemplate[SKPBOX]}
                  disabled={true}
                  defaultValue={props.boxId} 
                  noTranslate={true}
                />
              </MarginLeft>
            </WidthForTextBox>
              <XDivider width="20px" /> </>}
          <WidthForTextBox>
            <TextField
              fieldTemplate={formTemplate[DIVISIONBOX]}
              disabled={true}
              value={state.divisionId} 
              noTranslate={true}
            />
          </WidthForTextBox>
          <XDivider width="20px" />
          <WidthForTextBox>
            <TextField
              fieldTemplate={formTemplate[DEPARTMENTBOX]}
              disabled={true}
              value={state.departmentId} 
              noTranslate={true}
            />
          </WidthForTextBox>
        </EvenSpace></>
        : null}
    </BoxUp>
  )
}

SummaryHeader.propTypes = {
  jobId: PropTypes.string,
  dataKeyed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxId: PropTypes.string,
  templateType: PropTypes.bool,
  qualityCheck: PropTypes.bool,
  compact: PropTypes.bool, // AI code — QC compact header
  jobSummary: PropTypes.shape({
    customerId: PropTypes.string,
    templateName: PropTypes.string,
    divisionId: PropTypes.string,
    departmentId: PropTypes.string,
  }),
}


export default SummaryHeader